

import { FieldType } from './enum'

export default {
	props: {
        filterOptions: {
            type: Array,
            default: () => [],
            requried: true
        }
	},
	data() {
		return {
		}
	},
	computed: {
        actionList() {
            return this.filterOptions?.filter(x => {
                if (x.fieldType === FieldType.SECTION) {
                    return x.value?.min || x.value?.max
                }
                const values = x.value
                return values?.length && x.mappingField !== 'hotLabel'
            }).reduce((acc, item) => {
                if (item.fieldType === FieldType.SINGLE_CASCADE) {
                    const values = item.value
                    if (values?.length) {
                        acc.push({
                            mappingField: item.mappingField,
					        name: values[values.length - 1]?.nickName || values[values.length - 1]?.name || ''
                        })
                    }
                }
                // 区间类型处理
                else if (item.fieldType === FieldType.SECTION) {
                    // 无最大值，则显示>=最小值
                    if (item.value?.max === '') {
                        acc.push({
                            mappingField: item.mappingField,
                            name: `${item.name}：>=${item.value?.min}`
                        })
                    }
                    else {
                        // 区间类型处理
                        acc.push({
                            mappingField: item.mappingField,
                            name: `${item.name}：${item.value?.min || '0'}-${item.value?.max || ''}`
                        })
                    }
                }
                else {
                    const values = item.value
                    values?.forEach(valueItem => {
                        acc.push({
                            mappingField: item.mappingField,
					        name: valueItem?.nickName || valueItem?.name || valueItem
                        })
                    })
                }

                return acc
            }, [])
        }
	},
	methods: {
         removeFilterItem(item) {
            this.$emit('removeFilterItem', item, this.actionList)
        },
	},
	mounted() {}
}
